import RestClient from './rest-client'

export default class TransferFunds extends RestClient {
  static get url () {
    return this.apiUrl + '/transfer_funds'
  }
  
  static get paramKey () {
    return 'transfer_funds'
  }

  static async sendPaymentProof (formData) {
    const { data } = await this._post(this.url + '/send_payment_proof', formData)
    return data
  }

  static async mercadoPago (formData) {
    const { data } = await this._post(this.url + '/mercado_payment_process', formData)
    return data
  }
  static async mercadoPagoCreatePreference (formData) {
    const { data } = await this._post(this.url + '/mercado_create_preference', formData)
    return data
  }
}